import { render, staticRenderFns } from "./VoyageHistoryList.vue?vue&type=template&id=51876bda&"
import script from "./VoyageHistoryList.vue?vue&type=script&lang=js&"
export * from "./VoyageHistoryList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports